module.exports = __webpack_public_path__ + "img/800x520_bridgestoneplus.6ae3859f.jpg";